import { Component } from "@angular/core";

@Component({
  selector: "app-fuel-savings-modal",
  templateUrl: "./fuel-savings-modal.component.html",
  styleUrls: ["./fuel-savings-modal.component.scss"]
})
export class FuelSavingsModalComponent {}
